import { reservesConfig } from '../../../../config';
import { CopyAmountChangeOptions } from './useCopyAmountChange';
import { http } from '../../../../api/axios';

export function changeReserveCopyAmount(reserveListId: string, options: CopyAmountChangeOptions) {
    const { productId, numCopies, command } = options;
    return http
        .post(
            reservesConfig().endpointReserveProductCopyAmountChange,
            {
                action: command,
                amount: numCopies
            },
            {
                pathParams: {
                    reserveListId,
                    productId
                }
            }
        )
        .then(() => true);
}
